import NearMissReporter from "./components/NearMissReporter";

export default NearMissReporter